import { actionTypes } from "./actions";

const initialState = {
  data: [],
  productsEdit: {
    ProductCode: "",
    ProductDescription: "",
    ProductFamilyBrandCode: "",
    ProductFamilyBrandDescription: "",
    ProductCigaretteSizeCode: "",
    ProductEANCode: "",
    Product_ProductGroupSK: "",
    ProductActiveFrom: null,
    ProductActiveTo: null,
    ProductGroupCode: "",
    ProductGroupDescription: "",
    ProductBlisterFlag: "",
    ProductCapsule: "",
    Product_CapsuleTypeSk: "",
    ProductCapsuleType: "",
    ProductCategoryCode: "",
    ProductCategoryParamDescription: "",
    ProductNumberOfCigarettesDescription: "",
    CapsuleTypes: [],
    BrandOptions: [],
    CategoryOptions: [],
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_PRODUCTS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_PRODUCTS_BY_ID:
      return {
        ...state,
        productsEdit: {
          ...payload,
          ProductCategoryParamDescription: payload.ProductCategoryDescription,
          CapsuleTypes: state.productsEdit.CapsuleTypes,
          BrandOptions: state.productsEdit.BrandOptions,
          CategoryOptions: state.productsEdit.CategoryOptions,
        }
      };

    case actionTypes.SET_UPDATED_PRODUCT:
      return {
        ...state,
        productsEdit: payload,
      };

    case actionTypes.EDIT_PRODUCTS_FORM_CHANGE:
      return {
        ...state,

        productsEdit: {
          ...state.productsEdit,
          [payload.name]: payload.value,
        },
      };

    case actionTypes.SET_FILTERED_PRODUCTS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_PRODUCTS_CAPSULES:
      return {
        ...state,
        productsEdit: {
          ...state.productsEdit,
          CapsuleTypes: payload,
        },
      };

    case actionTypes.SET_BRAND_OPTIONS:
        return {
          ...state,
          productsEdit: {
            ...state.productsEdit,
            BrandOptions: payload,
          },
        };

    case actionTypes.SET_CATEGORY_OPTIONS:
        return {
          ...state,
          productsEdit: {
            ...state.productsEdit,
            CategoryOptions: payload,
          },
        };

    default:
      return {
        ...state,
      };
  }
};
